import baseInfo from './baseInfo.vue';
export default baseInfo;


// WEBPACK FOOTER //
// ./src/staticComponents/baseInfo/index.js